export const shoppingTipsArticleId = 28;
